import * as TogglePrimitive from '@radix-ui/react-toggle';
import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '@/services/utils';

const toggleVariants = cva(
    `tw-inline-flex
     tw-items-center
     tw-justify-center
     tw-text-t-sm
     tw-font-medium
     tw-transition-colors
     tw-border-none
     tw-cursor-pointer
     focus-visible:tw-outline-none focus-visible:tw-ring-1 focus-visible:tw-ring-ring
     disabled:tw-pointer-events-none disabled:tw-opacity-50
     tw-bg-transparent`,
    {
        variants: {
            variant: {
                primary: 'data-[state=on]:tw-text-primary',
                secondary: 'data-[state=on]:tw-text-secondary',
                dark: 'data-[state=on]:tw-text-dark',
                light: 'data-[state=on]:tw-text-light'
            },
            size: {
                default: 'tw-h-8 tw-px-2',
            },
        },
        defaultVariants: {
            variant: 'primary',
            size: 'default',
        },
    }
);

const Toggle = React.forwardRef<
    React.ElementRef<typeof TogglePrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof TogglePrimitive.Root> &
        VariantProps<typeof toggleVariants>
>(({ className, variant, size, ...props }, ref) => (
    <TogglePrimitive.Root
        ref={ref}
        className={cn(toggleVariants({ variant, size, className }))}
        {...props}
    />
));

Toggle.displayName = TogglePrimitive.Root.displayName;

export { Toggle, toggleVariants };
